import './Tooltip.css';

export const Tooltip = ({ interactionData }) => {
  if (!interactionData) {
    return null;
  }

  const {
    xPos,
    yPos,
    headline,
    color,
    y,
    media,
    ideology_label,
    age_value,
    traffic,
  } = interactionData;

  return (
    <div
      className='tooltip-container'
      style={{
        left: xPos,
        top: yPos,
      }}
    >
      <div className='tooltip-title'>{headline}</div>
      <div className='tooltip-subtitle'>
        <span>by </span>
        <b>{media}</b>
      </div>

      <div className='tooltip-separator' />

      <div className='media-info' style={{ borderColor: color }}>
        <div className='tooltip-row'>
          <span>Media creation year:</span>
          <b>{age_value}</b>
        </div>
        <div className='tooltip-row'>
          <span>Media ideology:</span>
          <b>{ideology_label}</b>
        </div>
        <div className='tooltip-row'>
          <span>Media traffic:</span>
          <b>{traffic}</b>
        </div>
      </div>

      <div className='tooltip-separator' />

      <div className='tooltip-row end'>
        <span>Stance score:</span>
        <b>{y}</b>
      </div>
    </div>
  );
};
